import { createIcon } from '@chakra-ui/icons';

export const ScreenVoice = createIcon({
  displayName: 'ScreenVoice',
  viewBox: '0 0 44 44',
  path: [
    <svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_211_3507)">
        <path
          d="M13.8088 41.6039C28.8975 48.1078 45.3685 35.8387 43.4566 19.5197C42.5687 11.9402 37.7016 5.41138 30.6912 2.39603C15.6025 -4.10779 -0.868461 8.16123 1.04339 24.4803C1.93136 32.0598 6.79845 38.5886 13.8088 41.6039Z"
          fill="#FEF3DF"
        />
        <path
          d="M36.7374 12.7066C36.7374 11.1594 35.4831 9.90518 33.936 9.90518H8.72326C7.1761 9.90518 5.92188 11.1594 5.92188 12.7066V30.6356H36.7374V12.7066Z"
          fill="#F6D59D"
        />
        <path
          d="M10.4041 9.90518H8.72326C7.17597 9.90488 5.92157 11.1593 5.92188 12.7066V30.6356L10.4041 26.687L29.4537 9.90518H10.4041Z"
          fill="white"
        />
        <path
          d="M11.25 39C11.25 39.7687 19.5833 40.2491 26.25 39.8647C29.344 39.6864 31.25 39.3567 31.25 39C31.25 38.2314 22.9167 37.7509 16.25 38.1353C13.156 38.3136 11.25 38.6433 11.25 39Z"
          fill="#F1CA89"
        />
        <path
          d="M26.0921 35.6782H16.5673C15.3296 35.6782 14.3262 36.6816 14.3262 37.9193C14.3262 38.2287 14.577 38.4796 14.8865 38.4795H27.7729C28.0824 38.4795 28.3332 38.2287 28.3332 37.9193C28.3332 36.6816 27.3298 35.6782 26.0921 35.6782Z"
          fill="#F6D59D"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6879 33.9973H24.9715V35.6781H17.6879V33.9973Z"
          fill="#F1CA89"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.7374 30.6356H5.92188V31.1959C5.92218 32.7429 7.17623 33.997 8.72326 33.9973H33.936C35.483 33.997 36.737 32.7429 36.7374 31.1959V30.6356Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7694 32.3165C20.7694 32.7478 21.2363 33.0173 21.6098 32.8017C21.7832 32.7016 21.8899 32.5166 21.8899 32.3165C21.8899 31.8852 21.4231 31.6156 21.0495 31.8312C20.8762 31.9313 20.7694 32.1163 20.7694 32.3165Z"
          fill="#453924"
        />
        <path
          d="M36.7374 12.7066C36.7374 11.1594 35.4831 9.90518 33.936 9.90518H8.72326C7.1761 9.90518 5.92188 11.1594 5.92188 12.7066V30.6356H36.7374V12.7066Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.78 25.8417C41.7779 26.5835 41.1771 27.1843 40.4353 27.1864H13.9793C13.2376 27.1843 12.6367 26.5835 12.6346 25.8417V8.85455H41.78V25.8417Z"
          fill="#F1CA89"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.78 25.8417C41.7779 26.5835 41.1771 27.1843 40.4353 27.1864H13.9793C13.2376 27.1843 12.6367 26.5835 12.6346 25.8417V8.85455H41.78V25.8417Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.7799 8.85456H12.634V5.56008C12.6361 4.81829 13.2369 4.21747 13.9787 4.21542H40.4352C41.177 4.21747 41.7778 4.81829 41.7799 5.56008V8.85456Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1804 6.53497C14.179 7.13017 14.8225 7.5037 15.3386 7.20732C15.5793 7.0691 15.7275 6.81249 15.7268 6.53497C15.7282 5.93977 15.0848 5.56624 14.5686 5.86262C14.3279 6.00079 14.1798 6.25741 14.1804 6.53497Z"
          fill="#B0D9FF"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2732 6.53497C17.2718 7.13017 17.9152 7.5037 18.4314 7.20732C18.6721 7.0691 18.8202 6.81249 18.8196 6.53497C18.821 5.93977 18.1775 5.56624 17.6614 5.86262C17.4207 6.00079 17.2725 6.25741 17.2732 6.53497Z"
          fill="#B0D9FF"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.366 6.53497C20.3645 7.13017 21.008 7.5037 21.5241 7.20732C21.7649 7.0691 21.913 6.81249 21.9123 6.53497C21.9137 5.93977 21.2703 5.56624 20.7541 5.86262C20.5135 6.00079 20.3653 6.25741 20.366 6.53497Z"
          fill="#B0D9FF"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.007 24.2457H38.4182"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.8694 17.6147C31.2173 17.4138 31.2173 16.9117 30.8694 16.7108L25.3285 13.5092C24.9806 13.3083 24.5457 13.5593 24.5457 13.9611C24.5457 13.9609 24.5457 13.9613 24.5457 13.9611V20.3617C24.5453 20.7634 24.9799 21.0149 25.328 20.8144C25.3278 20.8145 25.3282 20.8143 25.328 20.8144L30.8694 17.6147Z"
          fill="white"
        />
        <path
          d="M20.5004 25.0861C20.5004 25.7331 19.8001 26.1375 19.2398 25.814C18.9798 25.6639 18.8196 25.3864 18.8196 25.0861V23.4053C18.8196 22.7583 19.5199 22.354 20.0802 22.6775C20.3402 22.8276 20.5004 23.1051 20.5004 23.4053V25.0861Z"
          fill="white"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5457 13.9611C24.5457 13.5593 24.9806 13.3083 25.3285 13.5092L30.8694 16.7108C31.2173 16.9117 31.2173 17.4138 30.8694 17.6147L25.328 20.8144M24.5457 13.9611C24.5457 13.9613 24.5457 13.9609 24.5457 13.9611ZM24.5457 13.9611V20.3617C24.5453 20.7634 24.9799 21.0149 25.328 20.8144M25.328 20.8144C25.3282 20.8143 25.3278 20.8145 25.328 20.8144Z"
          stroke="#453924"
          strokeWidth="0.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_211_3507">
          <rect width="44" height="44" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
